/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const updatePhoto = /* GraphQL */ `mutation UpdatePhoto(
  $input: UpdatePhotoInput!
  $condition: ModelPhotoConditionInput
) {
  updatePhoto(input: $input, condition: $condition) {
    id
    tripId
    fileName
    s3Key
    uploadedBy
    status
    fileSize
    trip {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      storageUsed
      createdAt
      updatedAt
      __typename
    }
    contentType
    thumbnailS3Key
    thumbnailWidth
    thumbnailHeight
    thumbnailSize
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePhotoMutationVariables,
  APITypes.UpdatePhotoMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    name
    email
    phoneNumber
    storageTier
    storageUsed
    storageLimit
    friends {
      nextToken
      __typename
    }
    trips {
      nextToken
      __typename
    }
    stripeCustomerId
    subscriptionId
    subscriptionStatus
    subscriptionPeriodEnd
    appleSubscriptionId
    googleSubscriptionId
    appleReceiptData
    googlePurchaseToken
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    name
    email
    phoneNumber
    storageTier
    storageUsed
    storageLimit
    friends {
      nextToken
      __typename
    }
    trips {
      nextToken
      __typename
    }
    stripeCustomerId
    subscriptionId
    subscriptionStatus
    subscriptionPeriodEnd
    appleSubscriptionId
    googleSubscriptionId
    appleReceiptData
    googlePurchaseToken
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    name
    email
    phoneNumber
    storageTier
    storageUsed
    storageLimit
    friends {
      nextToken
      __typename
    }
    trips {
      nextToken
      __typename
    }
    stripeCustomerId
    subscriptionId
    subscriptionStatus
    subscriptionPeriodEnd
    appleSubscriptionId
    googleSubscriptionId
    appleReceiptData
    googlePurchaseToken
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createStorageTierConfig = /* GraphQL */ `mutation CreateStorageTierConfig(
  $input: CreateStorageTierConfigInput!
  $condition: ModelStorageTierConfigConditionInput
) {
  createStorageTierConfig(input: $input, condition: $condition) {
    id
    tier
    name
    storageBytes
    pricePerMonth
    features
    version
    isDefault
    createdAt
    updatedAt
    stripePriceId
    stripeProductId
    appleProductId
    googleProductId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStorageTierConfigMutationVariables,
  APITypes.CreateStorageTierConfigMutation
>;
export const updateStorageTierConfig = /* GraphQL */ `mutation UpdateStorageTierConfig(
  $input: UpdateStorageTierConfigInput!
  $condition: ModelStorageTierConfigConditionInput
) {
  updateStorageTierConfig(input: $input, condition: $condition) {
    id
    tier
    name
    storageBytes
    pricePerMonth
    features
    version
    isDefault
    createdAt
    updatedAt
    stripePriceId
    stripeProductId
    appleProductId
    googleProductId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStorageTierConfigMutationVariables,
  APITypes.UpdateStorageTierConfigMutation
>;
export const deleteStorageTierConfig = /* GraphQL */ `mutation DeleteStorageTierConfig(
  $input: DeleteStorageTierConfigInput!
  $condition: ModelStorageTierConfigConditionInput
) {
  deleteStorageTierConfig(input: $input, condition: $condition) {
    id
    tier
    name
    storageBytes
    pricePerMonth
    features
    version
    isDefault
    createdAt
    updatedAt
    stripePriceId
    stripeProductId
    appleProductId
    googleProductId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStorageTierConfigMutationVariables,
  APITypes.DeleteStorageTierConfigMutation
>;
export const createSubscriptionEvent = /* GraphQL */ `mutation CreateSubscriptionEvent(
  $input: CreateSubscriptionEventInput!
  $condition: ModelSubscriptionEventConditionInput
) {
  createSubscriptionEvent(input: $input, condition: $condition) {
    id
    userId
    eventType
    platform
    subscriptionId
    productId
    previousTier
    newTier
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubscriptionEventMutationVariables,
  APITypes.CreateSubscriptionEventMutation
>;
export const updateSubscriptionEvent = /* GraphQL */ `mutation UpdateSubscriptionEvent(
  $input: UpdateSubscriptionEventInput!
  $condition: ModelSubscriptionEventConditionInput
) {
  updateSubscriptionEvent(input: $input, condition: $condition) {
    id
    userId
    eventType
    platform
    subscriptionId
    productId
    previousTier
    newTier
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubscriptionEventMutationVariables,
  APITypes.UpdateSubscriptionEventMutation
>;
export const deleteSubscriptionEvent = /* GraphQL */ `mutation DeleteSubscriptionEvent(
  $input: DeleteSubscriptionEventInput!
  $condition: ModelSubscriptionEventConditionInput
) {
  deleteSubscriptionEvent(input: $input, condition: $condition) {
    id
    userId
    eventType
    platform
    subscriptionId
    productId
    previousTier
    newTier
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSubscriptionEventMutationVariables,
  APITypes.DeleteSubscriptionEventMutation
>;
export const createFriend = /* GraphQL */ `mutation CreateFriend(
  $input: CreateFriendInput!
  $condition: ModelFriendConditionInput
) {
  createFriend(input: $input, condition: $condition) {
    id
    userId
    friendId
    friendName
    phoneNumber
    invited
    user {
      id
      name
      email
      phoneNumber
      storageTier
      storageUsed
      storageLimit
      stripeCustomerId
      subscriptionId
      subscriptionStatus
      subscriptionPeriodEnd
      appleSubscriptionId
      googleSubscriptionId
      appleReceiptData
      googlePurchaseToken
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFriendMutationVariables,
  APITypes.CreateFriendMutation
>;
export const updateFriend = /* GraphQL */ `mutation UpdateFriend(
  $input: UpdateFriendInput!
  $condition: ModelFriendConditionInput
) {
  updateFriend(input: $input, condition: $condition) {
    id
    userId
    friendId
    friendName
    phoneNumber
    invited
    user {
      id
      name
      email
      phoneNumber
      storageTier
      storageUsed
      storageLimit
      stripeCustomerId
      subscriptionId
      subscriptionStatus
      subscriptionPeriodEnd
      appleSubscriptionId
      googleSubscriptionId
      appleReceiptData
      googlePurchaseToken
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFriendMutationVariables,
  APITypes.UpdateFriendMutation
>;
export const deleteFriend = /* GraphQL */ `mutation DeleteFriend(
  $input: DeleteFriendInput!
  $condition: ModelFriendConditionInput
) {
  deleteFriend(input: $input, condition: $condition) {
    id
    userId
    friendId
    friendName
    phoneNumber
    invited
    user {
      id
      name
      email
      phoneNumber
      storageTier
      storageUsed
      storageLimit
      stripeCustomerId
      subscriptionId
      subscriptionStatus
      subscriptionPeriodEnd
      appleSubscriptionId
      googleSubscriptionId
      appleReceiptData
      googlePurchaseToken
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFriendMutationVariables,
  APITypes.DeleteFriendMutation
>;
export const createTrip = /* GraphQL */ `mutation CreateTrip(
  $input: CreateTripInput!
  $condition: ModelTripConditionInput
) {
  createTrip(input: $input, condition: $condition) {
    id
    tripName
    description
    startDate
    endDate
    createdBy
    storageUsed
    members {
      nextToken
      __typename
    }
    photos {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTripMutationVariables,
  APITypes.CreateTripMutation
>;
export const updateTrip = /* GraphQL */ `mutation UpdateTrip(
  $input: UpdateTripInput!
  $condition: ModelTripConditionInput
) {
  updateTrip(input: $input, condition: $condition) {
    id
    tripName
    description
    startDate
    endDate
    createdBy
    storageUsed
    members {
      nextToken
      __typename
    }
    photos {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTripMutationVariables,
  APITypes.UpdateTripMutation
>;
export const deleteTrip = /* GraphQL */ `mutation DeleteTrip(
  $input: DeleteTripInput!
  $condition: ModelTripConditionInput
) {
  deleteTrip(input: $input, condition: $condition) {
    id
    tripName
    description
    startDate
    endDate
    createdBy
    storageUsed
    members {
      nextToken
      __typename
    }
    photos {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTripMutationVariables,
  APITypes.DeleteTripMutation
>;
export const createTripMember = /* GraphQL */ `mutation CreateTripMember(
  $input: CreateTripMemberInput!
  $condition: ModelTripMemberConditionInput
) {
  createTripMember(input: $input, condition: $condition) {
    id
    tripId
    userId
    role
    trip {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      storageUsed
      createdAt
      updatedAt
      __typename
    }
    user {
      id
      name
      email
      phoneNumber
      storageTier
      storageUsed
      storageLimit
      stripeCustomerId
      subscriptionId
      subscriptionStatus
      subscriptionPeriodEnd
      appleSubscriptionId
      googleSubscriptionId
      appleReceiptData
      googlePurchaseToken
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTripMemberMutationVariables,
  APITypes.CreateTripMemberMutation
>;
export const updateTripMember = /* GraphQL */ `mutation UpdateTripMember(
  $input: UpdateTripMemberInput!
  $condition: ModelTripMemberConditionInput
) {
  updateTripMember(input: $input, condition: $condition) {
    id
    tripId
    userId
    role
    trip {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      storageUsed
      createdAt
      updatedAt
      __typename
    }
    user {
      id
      name
      email
      phoneNumber
      storageTier
      storageUsed
      storageLimit
      stripeCustomerId
      subscriptionId
      subscriptionStatus
      subscriptionPeriodEnd
      appleSubscriptionId
      googleSubscriptionId
      appleReceiptData
      googlePurchaseToken
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTripMemberMutationVariables,
  APITypes.UpdateTripMemberMutation
>;
export const deleteTripMember = /* GraphQL */ `mutation DeleteTripMember(
  $input: DeleteTripMemberInput!
  $condition: ModelTripMemberConditionInput
) {
  deleteTripMember(input: $input, condition: $condition) {
    id
    tripId
    userId
    role
    trip {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      storageUsed
      createdAt
      updatedAt
      __typename
    }
    user {
      id
      name
      email
      phoneNumber
      storageTier
      storageUsed
      storageLimit
      stripeCustomerId
      subscriptionId
      subscriptionStatus
      subscriptionPeriodEnd
      appleSubscriptionId
      googleSubscriptionId
      appleReceiptData
      googlePurchaseToken
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTripMemberMutationVariables,
  APITypes.DeleteTripMemberMutation
>;
export const createPhoto = /* GraphQL */ `mutation CreatePhoto(
  $input: CreatePhotoInput!
  $condition: ModelPhotoConditionInput
) {
  createPhoto(input: $input, condition: $condition) {
    id
    tripId
    fileName
    s3Key
    uploadedBy
    status
    fileSize
    trip {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      storageUsed
      createdAt
      updatedAt
      __typename
    }
    contentType
    thumbnailS3Key
    thumbnailWidth
    thumbnailHeight
    thumbnailSize
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePhotoMutationVariables,
  APITypes.CreatePhotoMutation
>;
export const deletePhoto = /* GraphQL */ `mutation DeletePhoto(
  $input: DeletePhotoInput!
  $condition: ModelPhotoConditionInput
) {
  deletePhoto(input: $input, condition: $condition) {
    id
    tripId
    fileName
    s3Key
    uploadedBy
    status
    fileSize
    trip {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      storageUsed
      createdAt
      updatedAt
      __typename
    }
    contentType
    thumbnailS3Key
    thumbnailWidth
    thumbnailHeight
    thumbnailSize
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePhotoMutationVariables,
  APITypes.DeletePhotoMutation
>;
export const createTripInvitation = /* GraphQL */ `mutation CreateTripInvitation(
  $input: CreateTripInvitationInput!
  $condition: ModelTripInvitationConditionInput
) {
  createTripInvitation(input: $input, condition: $condition) {
    id
    tripId
    token
    role
    createdBy
    expiresAt
    usedBy
    usedAt
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTripInvitationMutationVariables,
  APITypes.CreateTripInvitationMutation
>;
export const updateTripInvitation = /* GraphQL */ `mutation UpdateTripInvitation(
  $input: UpdateTripInvitationInput!
  $condition: ModelTripInvitationConditionInput
) {
  updateTripInvitation(input: $input, condition: $condition) {
    id
    tripId
    token
    role
    createdBy
    expiresAt
    usedBy
    usedAt
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTripInvitationMutationVariables,
  APITypes.UpdateTripInvitationMutation
>;
export const deleteTripInvitation = /* GraphQL */ `mutation DeleteTripInvitation(
  $input: DeleteTripInvitationInput!
  $condition: ModelTripInvitationConditionInput
) {
  deleteTripInvitation(input: $input, condition: $condition) {
    id
    tripId
    token
    role
    createdBy
    expiresAt
    usedBy
    usedAt
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTripInvitationMutationVariables,
  APITypes.DeleteTripInvitationMutation
>;
export const deletePhotoWithAuth = /* GraphQL */ `mutation DeletePhotoWithAuth($photoId: ID!) {
  deletePhotoWithAuth(photoId: $photoId) {
    id
    tripId
    fileName
    s3Key
    uploadedBy
    status
    fileSize
    trip {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      storageUsed
      createdAt
      updatedAt
      __typename
    }
    contentType
    thumbnailS3Key
    thumbnailWidth
    thumbnailHeight
    thumbnailSize
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePhotoWithAuthMutationVariables,
  APITypes.DeletePhotoWithAuthMutation
>;
export const initStorageTiers = /* GraphQL */ `mutation InitStorageTiers {
  initStorageTiers {
    id
    tier
    name
    storageBytes
    pricePerMonth
    features
    version
    isDefault
    createdAt
    updatedAt
    stripePriceId
    stripeProductId
    appleProductId
    googleProductId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.InitStorageTiersMutationVariables,
  APITypes.InitStorageTiersMutation
>;
export const deleteTripWithAuth = /* GraphQL */ `mutation DeleteTripWithAuth($tripId: ID!) {
  deleteTripWithAuth(tripId: $tripId)
}
` as GeneratedMutation<
  APITypes.DeleteTripWithAuthMutationVariables,
  APITypes.DeleteTripWithAuthMutation
>;
export const removeTripMemberWithAuth = /* GraphQL */ `mutation RemoveTripMemberWithAuth($memberId: ID!, $deletePhotos: Boolean) {
  removeTripMemberWithAuth(memberId: $memberId, deletePhotos: $deletePhotos) {
    id
    tripId
    userId
    role
    photosDeleted
    storageFreed
    deletedPhotoIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveTripMemberWithAuthMutationVariables,
  APITypes.RemoveTripMemberWithAuthMutation
>;
export const createCheckoutSession = /* GraphQL */ `mutation CreateCheckoutSession(
  $tier: StorageTier!
  $successUrl: String
  $cancelUrl: String
) {
  createCheckoutSession(
    tier: $tier
    successUrl: $successUrl
    cancelUrl: $cancelUrl
  ) {
    sessionId
    url
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCheckoutSessionMutationVariables,
  APITypes.CreateCheckoutSessionMutation
>;
export const manageSubscription = /* GraphQL */ `mutation ManageSubscription(
  $subscriptionId: String!
  $action: SubscriptionAction!
) {
  manageSubscription(subscriptionId: $subscriptionId, action: $action) {
    subscriptionId
    status
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ManageSubscriptionMutationVariables,
  APITypes.ManageSubscriptionMutation
>;
export const deleteUserAccount = /* GraphQL */ `mutation DeleteUserAccount {
  deleteUserAccount {
    userId
    success
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserAccountMutationVariables,
  APITypes.DeleteUserAccountMutation
>;
export const validateApplePurchase = /* GraphQL */ `mutation ValidateApplePurchase($receiptData: String!, $productId: String!) {
  validateApplePurchase(receiptData: $receiptData, productId: $productId) {
    success
    subscriptionId
    expiresDate
    productId
    tier
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ValidateApplePurchaseMutationVariables,
  APITypes.ValidateApplePurchaseMutation
>;
export const validateGooglePurchase = /* GraphQL */ `mutation ValidateGooglePurchase($purchaseToken: String!, $productId: String!) {
  validateGooglePurchase(purchaseToken: $purchaseToken, productId: $productId) {
    success
    subscriptionId
    expiresDate
    productId
    tier
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ValidateGooglePurchaseMutationVariables,
  APITypes.ValidateGooglePurchaseMutation
>;
